import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { SubscriberType } from '@parkchirp/reporting';

type Props = {
	value: SubscriberType;
	onChange: (value: SubscriberType) => void;
};

export const SubscriberTypeFilter = ({ value, onChange }: Props) => {
	return (
		<Stack spacing={2}>
			<Typography variant='subtitle1' fontWeight={600}>
				Subscriber type
			</Typography>

			<FormControl fullWidth>
				<InputLabel id='subscriber-type-label'>Subscriber type</InputLabel>
				<Select
					labelId='subscriber-type-label'
					label='Subscriber type'
					value={value}
					onChange={(event) => onChange(event.target.value as SubscriberType)}
				>
					<MenuItem value='All'>All</MenuItem>
					<MenuItem value='Business'>Business</MenuItem>
					<MenuItem value='Individual'>Individual</MenuItem>
				</Select>
			</FormControl>
		</Stack>
	);
};
